export default "__VITE_ASSET__DuBkuf9x__"